import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sidenavitemtext',
  templateUrl: './sidenavitemtext.component.html',
  styleUrls: ['./sidenavitemtext.component.css'],
})
export class SidenavitemtextComponent implements OnInit {
  @Input() opened: boolean;
  @Input() text: string;

  constructor() {}

  ngOnInit(): void {}
}
